import { isFunction } from "lodash";

// This allows handling the assignation of both useRef and useCallback ref sources as
// available with the original React API.
//
export const assignForwardedRef = (ref, element) => {
  if (!ref) return;

  if (isFunction(ref)) {
    ref(element);
  } else {
    ref.current = element;
  }
};
